(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("potree2-brotli-decoder.worker", [], factory);
	else if(typeof exports === 'object')
		exports["potree2-brotli-decoder.worker"] = factory();
	else
		root["potree2-brotli-decoder.worker"] = factory();
})(self, () => {
return 